<template>
  <div class="column" :class="columnClasses">
    <div v-if="value" class="column__section">
      <div :class="{ 'text-highlighted': isComparisonEnabled }">
        {{ basicValue }}
      </div>
      <div v-if="isComparisonEnabled">
        {{ comparisonValue }}
      </div>
    </div>
    <div v-else class="column__section">
      <div
        class="column__sentiment-container"
        :class="{ 'column__sentiment-container--primary': isComparisonEnabled }"
      >
        <span>{{ reviewsCountBasic }} </span>
        <span class="column__percentage-value">{{ percentageBasic }} </span>
      </div>
      <div v-if="isComparisonEnabled" class="column__sentiment-container">
        <span>{{ reviewsCountComparison }} </span>
        <span class="column__percentage-value"
          >{{ percentageComparison }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewsCategoriesTriadTableColumn",
  props: {
    value: {
      type: Array
    },
    sentiment: {
      type: Object
    },
    columnName: {
      type: String,
      required: true
    },
    isComparisonEnabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basicValue() {
      return this.formatValue(this.value[0]);
    },
    comparisonValue() {
      return this.formatValue(this.value[1]);
    },
    reviewsCount() {
      return this.sentiment.reviews_count;
    },
    percentage() {
      return this.sentiment.percentage;
    },
    reviewsCountBasic() {
      return this.formatValue(this.reviewsCount[0]);
    },
    percentageBasic() {
      return this.formatValue(this.percentage[0], "%");
    },
    reviewsCountComparison() {
      return this.formatValue(this.reviewsCount[1]);
    },
    percentageComparison() {
      return this.formatValue(this.percentage[1], "%");
    },
    columnClasses() {
      const columnClasses = {
        positive: "column--is-positive",
        neutral: "column--is-neutral",
        negative: "column--is-negative"
      };

      return columnClasses[this.columnName];
    }
  },
  methods: {
    formattedNumber(value) {
      return this.$options.filters.formatNumber(value);
    },
    formatValue(value, unit = "") {
      return !value ? "-" : `${value}${unit}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.text-highlighted {
  color: $primary;
  font-weight: bold;
}

.column {
  position: absolute;
  left: 4px;
  top: 4px;
  margin: auto;
  height: calc(100% - 8px);
  width: calc(100% - 8px);

  display: flex;
  align-items: center;
  padding: $spacing * 2;
  margin: $spacing * 0.5 0 $spacing * 0.5 0;
  justify-content: center;

  &__sentiment-container {
    display: flex;
    align-items: center;
    justify-content: center;

    &--primary {
      color: $primary;
    }
  }

  &__section {
    display: flex;
    flex-direction: column;
  }

  &__percentage-value {
    font-weight: bold;
    margin-left: $spacing * 1.5;
  }

  &--is-positive {
    background-color: rgba(#29c15b, 0.2);
  }
  &--is-neutral {
    background-color: rgba(#dbda1f, 0.2);
  }
  &--is-negative {
    background-color: rgba(#ff306e, 0.2);
  }
}
</style>
